<template>
    <div class="customer-information section-box">
        <el-tabs type="border-card" v-model="tabId">
            <el-tab-pane name="id_1" label="大客户配置" lazy>
                <vip-allocation-edit ref="vipAllocationEdit"></vip-allocation-edit>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import vipAllocationEdit from "./index/vipAllocationEdit";
    export default {
        components: {
            vipAllocationEdit
        },
        data() {
            return {
                // isCustomerEdit: false,
                // isvipAllocationEdit: false,
                tabId: 'id_1'
            };
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                //每次进入都显示客户信息页面
                // vm.tabId = 'id_1';
                // vm.isCustomerEdit = false;
                // vm.$refs.customerInfo.pageInit();
                
                // vm.$refs.vipAllocationEdit.getVipInfo();
            })
        },
        methods: {
            // changevipAllocationState(data){
            //     this.isvipAllocationEdit = data;
            //     if (data) {
            //         this.$refs.vipAllocationEdit.getVipInfo();
            //     } else {
            //         this.$refs.vipAllocation.getVipInfo();
            //     }
            // },
        },
    };
</script>
<style lang="scss">
    // .customer-information{

    // }
</style>
